const index = () => import('@/pages/tutorial/index.vue');

export default [{
    path: '/tutorial',
    component: index,
    meta: [{
        name: '首页'
    },
    {
        name: '新手教程配置',
        activeRoute: '/tutorial'
    }]
}];